import { StoreProfileEnum } from './enums';
import { IPermissionMapping } from './types';

export const PERMISSIONS: IPermissionMapping = {
  [StoreProfileEnum.MASTER_ADMIN]: {
    isAdmin: true,
    isStore: false,
    isMaster: true,
    isGroupAdmin: false,
    changeLMI: true,
    changePhonePrice: false,
    openProductList: true,
    contractingReadOnly: true,
    shouldFilterByStore: true,
    allowZeroLMI: true,
  },
  [StoreProfileEnum.GROUP_ADMIN]: {
    isAdmin: true,
    isStore: false,
    isMaster: false,
    isGroupAdmin: true,
    changeLMI: false,
    openProductList: false,
    changePhonePrice: false,
    contractingReadOnly: true,
    shouldFilterByStore: true,
    allowZeroLMI: false,
  },
  [StoreProfileEnum.STORE]: {
    isAdmin: false,
    isStore: true,
    isMaster: false,
    isGroupAdmin: false,
    changeLMI: false,
    openProductList: true,
    changePhonePrice: true,
    contractingReadOnly: false,
    shouldFilterByStore: false,
    allowZeroLMI: false,
  },
  [StoreProfileEnum.IN_APP]: {
    isAdmin: false,
    isStore: true,
    isMaster: false,
    isGroupAdmin: false,
    changeLMI: false,
    openProductList: false,
    changePhonePrice: false,
    contractingReadOnly: false,
    shouldFilterByStore: false,
    allowZeroLMI: false,
  },
  [StoreProfileEnum.ONLINE]: {
    isAdmin: false,
    isStore: true,
    isMaster: false,
    isGroupAdmin: false,
    contractingReadOnly: false,
    changeLMI: false,
    changePhonePrice: false,
    openProductList: false,
    shouldFilterByStore: false,
    allowZeroLMI: false,
  },
  [StoreProfileEnum.EMPTY]: {
    isAdmin: false,
    isStore: false,
    isMaster: false,
    isGroupAdmin: false,
    contractingReadOnly: false,
    changeLMI: false,
    changePhonePrice: false,
    openProductList: false,
    shouldFilterByStore: false,
    allowZeroLMI: false,
  },
};
